import React from 'react'
import { Container, Box, Typography, Button, Grid } from '@mui/material'
import logo from '../../Assets/images/PNG/Home/LOgo.png'
import { Link } from 'react-router-dom';
import './MainFooter.css'


const MainFooter = () => {
  return (
    <Box className='mainFooter'>
      <Container className="footer" >
        <Box className="footerUpperTex">
          <p   className='FooterUpperText'>Email for Enquiries & Beta Access</p>
          <Button variant="contained" color="primary" sx={{ padding: '25px 35px', borderRadius: "10px", fontWeight: 'bold', width: "200px", marginTop: "0px" }}>Try for free</Button>
        </Box>
      </Container>
      <Box className='blackfoter'>
        <Container >
          <Grid container spacing={4}>
            <Grid item md={6} sm={6} xs={12}>
              <Box>
                <img src={logo} alt="" />
                <Typography variant="body1" color="white">
                  Manage forms easily.<br /> Everywhere, everytime.
                </Typography>
              </Box>
            </Grid>
            <Grid item md={6} sm={6} xs={12}>
              <Box className='footer_menu'>
                <ul>
                  <li> <Link to='/' style={{ textDecoration: "none", color: 'white' }}>Home</Link></li>
                  <li> <Link to='/' style={{ textDecoration: "none", color: 'white' }}>About</Link></li>
                  <li> <Link to='/' style={{ textDecoration: "none", color: 'white' }}>FAQs</Link></li>
                  <li> <Link to='/' style={{ textDecoration: "none", color: 'white' }}>Testimonials</Link></li>
                </ul>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  )
}

export default MainFooter